<div class="modal-header">
    <h5 class="modal-title">{{type}}</h5>
</div>
<div class="modal-body">
    <p>{{message}}</p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="closeModal()">
        Confirm</button>
</div>